import { API } from './../constants'
import authService from './auth.js'

let mentorias = null
let alumnos = null
let condicionesMentorias = null
let mentoriasAbiertas = null
let mentoriasCerradas = null

const mentorService = {
  async checkMentorPorId (id) {
    const fetchResponse = await fetch(`${API}/mentor/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    return { ...respuesta }
  },
  async checkCupoMentoresPorMentorId (id) {
    const fetchResponse = await fetch(`${API}/check-mentor-cupo/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    return { ...respuesta }
  },
  async chequearInscripcionExamenPorPersonaIdPorServicioId (id1, id2) {
    const fetchResponse = await fetch(`${API}/check-inscipcion-examen/${id1}/${id2}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    return { ...respuesta }
  },
  async checkInscripcionPorMentorPorPersonaId (id) {
    const fetchResponse = await fetch(`${API}/mentor-check-inscipciones/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    return { ...respuesta }
  },
  async chequearInscripcionCompleta (id) {
    const fetchResponse = await fetch(`${API}/inscripcion-completa-examen/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    return { ...respuesta }
  },
  async checkMostrarBotonExamenPorPersonaId (id1, id2) {
    const fetchResponse = await fetch(`${API}/inscripcion-examen-mostrar-boton/${id1}/${id2}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    return { ...respuesta }
  },
  async checkMostrarBotonMesaDeExamenPorPersonaId (id) {
    const fetchResponse = await fetch(`${API}/mesas-de-examenes-mostrar-boton/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    return { ...respuesta }
  },
  async traerMentoriasAbiertasPorPersonaId (id) {
    const fetchResponse = await fetch(`${API}/mentorias-abiertas/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    mentoriasAbiertas = respuesta.data
    return [...mentoriasAbiertas]
  },
  async traerMentoriasCerradasPorPersonaId (id) {
    const fetchResponse = await fetch(`${API}/mentorias-cerradas/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    mentoriasCerradas = respuesta.data
    return [...mentoriasCerradas]
  },
  async traerMentoriasPorFiltro (data) {
    const fetchResponse = await fetch(`${API}/mentorias-filtro/${data}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    mentorias = respuesta.data
    return [...mentorias]
  },
  crearMentor (data) {
    return fetch(`${API}/crear-mentor`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        ...authService.tokenHeader()
      }
    })
      .then(rta => rta.json())
      .then(respuesta => {
        return { ...respuesta }
      })
  },
  finMentoria (data, id) {
    return fetch(`${API}/fin-mentoria/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        ...authService.tokenHeader()
      }
    })
      .then(rta => rta.json())
      .then(respuesta => {
        return { ...respuesta }
      })
  },
  borrarFinalizacionMentoria (id) {
    return fetch(`${API}/eliminar-fin-mentoria/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
      .then(rta => rta.json())
      .then(res => {
        return { ...res }
      })
  },
  borrarMentoria (id) {
    return fetch(`${API}/borrar-mentoria/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
      .then(rta => rta.json())
      .then(res => {
        return { ...res }
      })
  },
  editarMentoria (data, id) {
    return fetch(`${API}/editar-mentoria/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        ...authService.tokenHeader()
      }
    })
      .then(rta => rta.json())
      .then(respuesta => {
        console.log(respuesta)
        return { ...respuesta }
      })
  },
  async traerMentoriasTodas () {
    const fetchResponse = await fetch(`${API}/listar-mentorias`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    mentorias = respuesta.data
    return [...mentorias]
  },
  async traerCondicionesMentoriaTodos () {
    const fetchResponse = await fetch(`${API}/condiciones-mentorias`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    condicionesMentorias = respuesta.data
    return [...condicionesMentorias]
  },
  async traerMentoresConMentoriasTodos () {
    const fetchResponse = await fetch(`${API}/listar-mentores-con-mentorias`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    return { ...respuesta }
    // mentores = respuesta.data
    // return [...mentores]
  },
  async traerAlumnosPorProfeTodos () {
    const fetchResponse = await fetch(`${API}/listar-alumnos-todos-por-profe`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    alumnos = respuesta.data
    return [...alumnos]
  },
  async traerAlumnosPorProfe (id) {
    const fetchResponse = await fetch(`${API}/listar-alumnos-por-profe/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...authService.tokenHeader()
      }
    })
    const respuesta = await fetchResponse.json()
    alumnos = respuesta.data
    return [...alumnos]
  }
}

export default mentorService
